/**
 * useMemo for class components: returns what compute() returned last time, while every input is the same (===) as
 * then. For values a memoised child compares, such as the columns of a Table, which re-renders all its rows for new
 * columns.
 *
 *     this.columnsMemo = createMemo()
 *
 *     columns() {
 *         return this.columnsMemo([this.props.reseller, this.state.customers], () => this.buildColumns())
 *     }
 */
export default function createMemo<T>(): (inputs: unknown[], compute: () => T) => T {
    let previous: {inputs: unknown[], value: T} | undefined

    return (inputs, compute) => {
        const last = previous

        if (last && last.inputs.length === inputs.length && inputs.every((input, index) => input === last.inputs[index])) {
            return last.value
        }

        previous = {inputs, value: compute()}

        return previous.value
    }
}
